























import { Component, Vue, Prop } from "vue-property-decorator";
import { TermModel } from "../models";
import money from "shared/filters/money";

@Component({
  filters: {
    money
  }
})
export default class TermList extends Vue {
  @Prop({ required: true })
  value!: TermModel[];

  pagination = {
    rowsPerPage: -1
  };
}
